<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5"
                    ><span v-if="titulo">{{ titulo }} - </span
                    >CONTRATAÇÕES</span
                >
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="contratacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <btn-gestor-designado
                            class="float-right"
                            :contratacoes="contratacoesSelecionadas"
                            :contratacoesServicos="contratacoesServicos"
                            @obterAtualizacao="obterAtualizacao()"
                        ></btn-gestor-designado>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="selecoes" slot-scope="data">
                        <b-form-checkbox
                            :value="data"
                            v-model="contratacoesSelecionadas"
                        ></b-form-checkbox>
                        <slot name="selecoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import BtnGestorDesignado from './BtnGestorDesignado'

export default {
    props: {
        contratacoes: {
            type: Array,
            default: () => []
        },

        titulo: {
            type: String,
            default: () => ''
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnGestorDesignado
    },

    data() {
        return {
            contratacoesSelecionadas: [],
            campos: [
                {
                    key: 'selecoes',
                    label: ''
                },
                {
                    key: 'codContratacao',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoDescr',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'gestor',
                    label: 'Gestor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'gestorDesignado',
                    label: 'Gestor Designado',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fimDesignacaoGestor',
                    label: 'Fim Designação',
                    sortable: true,
                    type: 'date'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterAtualizacao() {
            this.contratacoesSelecionadas = []
            this.$emit('obterAtualizacao')
        }
    }
}
</script>
